import { render } from "./Tile.vue?vue&type=template&id=0cba5ef8&scoped=true&bindings={}"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"

import "./Tile.vue?vue&type=style&index=0&id=0cba5ef8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0cba5ef8"

export default script